import { I18n } from "@/i18n/I18n";
import { operationTypes } from "@/types/operationTypes";
import { ExclamationTriangleFilled } from "@/frontend/SVGs/ExclamationTriangleFilled";
import { InfoCircleFilled } from "@/frontend/SVGs/InfoCircleFilled";

const CALLOUT_COLOR_CLASSES: Partial<Record<operationTypes, string>> = {
  [operationTypes.Warning]: 'text-warning-emphasis',
  [operationTypes.Danger]: 'text-danger-emphasis',
  [operationTypes.Information]: 'text-primary',
};

// lh-1 keeps the icon from stretching the line box it sits in, so a callout label
// hugs its text instead of growing taller than the type it labels.
//
// The nudge centers the icon on the text it labels rather than on the line box.
// Centering on the box splits the font's ascent and descent, but a callout label is
// uppercase and a callout title has no descenders, so their ink sits entirely above
// the baseline and a box-centered icon reads low against them.
const ALIGN_TO_TEXT_INK = { transform: 'translateY(-0.04em)' };

export function CalloutIcon(props: { type: operationTypes, size?: number }) {
  const { type, size } = props;
  const colorClass = CALLOUT_COLOR_CLASSES[type];
  if (!colorClass) return null;

  return (
    <span role="img" aria-label={I18n.get(type)} style={ALIGN_TO_TEXT_INK} className={`d-inline-flex align-items-center lh-1 ${colorClass}`}>
      {type === operationTypes.Information ? <InfoCircleFilled size={size} /> : <ExclamationTriangleFilled size={size} />}
    </span>
  );
}
